import ApplicationSummary from './ApplicationSummary';

export default ApplicationSummary;
